module.exports = __webpack_public_path__ + "static/img/2en.71e19e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/xiaomi/2en.png
// module id = aPWD
// module chunks = 0